// extracted by mini-css-extract-plugin
module.exports = {"cardGrid":"IndividualsCards_cardGrid__jTp5k"};